import { useState, useRef, useEffect } from "react";

/** Auto-resize un input selon son contenu texte */
export function useAutoResizeInput(value: string, minWidth: number = 180) {
  const ref = useRef<HTMLInputElement>(null);
  const [width, setWidth] = useState(minWidth);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const span = document.createElement("span");
    span.style.visibility = "hidden";
    span.style.position = "absolute";
    span.style.whiteSpace = "pre";
    span.style.fontSize = window.getComputedStyle(el).fontSize;
    span.style.fontFamily = window.getComputedStyle(el).fontFamily;
    span.style.padding = window.getComputedStyle(el).padding;
    span.textContent = value || el.placeholder;
    document.body.appendChild(span);

    const textWidth = span.offsetWidth;
    document.body.removeChild(span);

    const newWidth = Math.max(minWidth, textWidth + 20);
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setWidth(newWidth);
  }, [value, minWidth]);

  return { ref, style: { width: `${width}px` } };
}
